import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';

import {AuthenticationService} from '../authentication.service';

@Injectable({
    providedIn: 'root'
})
export class LuxEngineGuard {
    constructor(private authService: AuthenticationService, private router: Router) {
    }

    canActivate(): Observable<boolean> {
        return this.authService.isLuxEngine$.pipe(
            take(1),
            map(isLuxEngine => {
                if (isLuxEngine) {
                    this.router.navigate(['/home/jobs']);
                    return false;
                }
                return true;
            })
        );
    }
}
